import gql from 'graphql-tag';

export default gql`
  mutation ($_id: MongoID!) {
    removeCourseItem(_id: $_id) {
      recordId
    }
  }
`;
